import Loading from '../../../Common/Loading';
import { ByPoliceStation } from './ByPoliceStation';
import { BySectional } from './BySectional';
import { ByDepartment } from './ByDepartment';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';
import { BySectionalElaboration } from './BySectionalElaboration';
import { ByPoliceStationElaboration } from './ByPoliceStationElaboration';
import { ByDepartmentElaboration } from './ByDepartmentElaboration';
import { ByMunicipalityElaboration } from './ByMunicipalityElaboration';

export const Charts = () => {
    const { isLoading } = useRankingsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ByPoliceStation />
                <ByPoliceStationElaboration />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ByDepartment />
                <ByDepartmentElaboration />
            </div>
            <div className="charts-side-by-side-dashboards">
                <BySectional />
                <BySectionalElaboration />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ByMunicipalityElaboration />
            </div>
        </>
    );
};
